import * as Debug from "debug";
import { Guid } from "../../../themes/fsm/src/hacks";
import {CRMMapClass} from "../crmmap/CRMMapClass";

interface EventFunction {
    (e: any): void;
}
class Event {

    name: string; 
    functions: EventFunction[] = [];
    parent: TObject;
    enabled: boolean= true;

    constructor(parent: TObject, name: string) {
        this.name = name;
        this.parent = parent;
    }

    addFunction(f: EventFunction) {
        this.functions.push(f);
    }

    trigger(e: any) {
        if (this.enabled) {
            this.functions.forEach((f) => {
                f(e);
            });
        }
     
    }
}


// TObject: Cause im lazy and could not think of a better name
// Add events and basic functions to my objects
export class TObject {
    parent: TObject;
    _CRMMap:CRMMapClass = null;
    debug: any;
    events: { [key: string]: Event } = {};
    visible: boolean = true;
    classname: string = 'Object';
    guid: string ='';

    constructor(parent: TObject) {
        this.guid = Guid.newGuid();
        this.parent = parent;
        if (parent) {
            this._CRMMap = parent.CRMMap();       
        }
        this.classname = this.getClassName();
        this.debug = Debug('CRMMap:' + this.classname);
      //  this.debug('Created');

    }

    destory() {
        this.debug('Destroyed');
    }

    /* --- Trigger Functions --------------*/

    when(w: string, d: EventFunction) {
        this.event(w).addFunction(d);
    }

    trigger(w:string, e: any = null) {
        if (this.events[w] != undefined) {
            this.events[w].trigger(e);
        }
    }

    event(w:string) {
        if (!this.events[w]) {
            this.events[w] = new Event(this, w);
        }
        return this.events[w];
    }

    /* --- Changed Functions --------------*/
    changed(e: any = this) {
        this.trigger('changed', e);
    }

    /* --- Visible Functions --------------*/
    setVisible(to: boolean) {
        if (this.visible != to) {
            this.visible = to;
            this.trigger('visible');
        }
    }

    hide() { this.setVisible(false); }
    show() { this.setVisible(true); }

    /* ----------------------------------*/

    //get the class name, not for comparison just info
    //results will be not what expected when minimized and optimized
    public getClassName() {
        var funcNameRegex = /function (.{1,})\(/;
        var results = (funcNameRegex).exec(this["constructor"].toString());
        return (results && results.length > 1) ? results[1] : "";
    }

    //this is a bit of a hack, but every object 'should' go back to a CRMMapClass
    //At some stage
    public CRMMap():CRMMapClass {
        return this._CRMMap;
    }
}

/*
CRMMap: CRMMapClass = null;*/

export class TMapObject extends TObject{

    map: google.maps.Map = null;
  
    constructor(parent: TObject) {
       super(parent);
     }

    setMap(map: google.maps.Map): TObject {
        this.map = map;
        this.trigger('map',this.map);
        return this;
    } 
}
